import { start } from './_handle_view/start';
import { onUpdateFactory } from './_handle_view/on_update_factory';
import { getTyroolaGlobals } from '../_global/get_tyroola_globals';

const defaultGlobals = getTyroolaGlobals();

export const handleView = (stores, render, options, container, globals = defaultGlobals) =>
    container && start(stores, onUpdateFactory(stores, options, container, render, globals));
